import type { ChatItemIdentity } from '../../../contracts/harness.types';

export type SeenAtMs = { first: number; last: number };

/** Same reference when unchanged (no-op guards depend on it). `first` never moves later. */
export const observeFrame = (
  seen: SeenAtMs | undefined,
  frameMs: number | undefined
): SeenAtMs | undefined => {
  if (frameMs === undefined) return seen;
  if (!seen) return { first: frameMs, last: frameMs };
  if (frameMs >= seen.first && frameMs <= seen.last) return seen;
  return { first: Math.min(seen.first, frameMs), last: Math.max(seen.last, frameMs) };
};

/** Defined identity keys only — `iteration: 0` must survive. */
export const presentIdentity = ({
  turnId,
  iteration,
  createdAt,
  seenAtMs,
}: {
  turnId?: string;
  iteration?: number;
  createdAt?: string;
  seenAtMs?: SeenAtMs;
}): Partial<ChatItemIdentity> => ({
  ...(turnId !== undefined && { turnId }),
  ...(iteration !== undefined && { iteration }),
  ...(createdAt !== undefined && { createdAt }),
  ...(seenAtMs !== undefined && { seenAtMs }),
});
